import { render, staticRenderFns } from "./ClassifierName.vue?vue&type=template&id=93eba634&"
import script from "./ClassifierName.vue?vue&type=script&lang=js&"
export * from "./ClassifierName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports